module.exports = __webpack_public_path__ + "img/css-framework4.6e23c5ed.png";